import { render, staticRenderFns } from "./productTypeDetail.vue?vue&type=template&id=c216568c&scoped=true"
import script from "./productTypeDetail.vue?vue&type=script&lang=js"
export * from "./productTypeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c216568c",
  null
  
)

export default component.exports